import { Modal as ModalAntd, Space } from 'antd';
import type { Dispatch, ReactNode, SetStateAction } from 'react';

interface ModalComponentProps {
  title?: string;
  content?: ReactNode;
  width?: number;
  closable?: boolean;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  centered?: boolean;
  destroyOnClose?: boolean;
  modalTrigger: (onClick: () => void) => ReactNode;
}

const Modal = ({
  title,
  content,
  width = 550,
  closable = true,
  open,
  setOpen,
  centered = true,
  destroyOnClose = true,
  modalTrigger,
}: ModalComponentProps) => {
  return (
    <Space>
      {modalTrigger(() => setOpen(true))}
      <ModalAntd
        centered={centered}
        closable={closable}
        destroyOnHidden={destroyOnClose}
        footer={null}
        open={open}
        title={title}
        width={width}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      >
        {content}
      </ModalAntd>
    </Space>
  );
};

export default Modal;
